import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import Multiselect from 'multiselect-react-dropdown'
import { isEmpty, masterAndChildIntersection } from '../../../utils/helper'

const CreateCmsUser = ({ openModal, onCancel, roleData, userData, addCallback, editCallback }) => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [passwordHide, setPasswordHide] = useState(false)
  const [phone, setPhone] = useState('')
  const [selectedRoles, setSelectedRoles] = useState([])
  const [selectedEditRoles, setSelectedEditRoles] = useState([])
  const [errorData, setErrorData] = useState({})

  useEffect(() => {
    if (!isEmpty(userData)) {
      handleEdit()
    }
  }, [])

  const handleEdit = () => {
    let tempRole = []
    roleData.forEach((ele) => {
      let roleIndex = userData.roles.findIndex((e) => e === ele._id)
      if (roleIndex > -1) {
        tempRole.push(ele)
      }
    })
    const roleIntersectionData = masterAndChildIntersection(roleData, tempRole)

    setSelectedRoles(roleIntersectionData.map((obj) => obj._id))
    setSelectedEditRoles(roleIntersectionData)
  }
  const handleChange = (event, func) => {
    const { value } = event.target
    func(value)
  }

  const handleSelectRoles = (info, type) => {
    let temp = selectedRoles
    if (type === 'add' && temp.indexOf(info._id) === -1) {
      temp.push(info._id)
    } else if (type === 'remove') {
      temp = temp.filter((id) => id !== info._id)
    }
    setSelectedRoles(temp)
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (isEmpty(userData) && !name && name.trim().length === 0) {
      isFormValid = false
      temp.name = 'Name cannot be Empty!'
    }
    if (isEmpty(userData) && !email && email.trim().length === 0) {
      isFormValid = false
      temp.email = 'Email cannot be Empty!'
    }
    if (isEmpty(userData) && !password && password.trim().length === 0) {
      isFormValid = false
      temp.password = 'Password cannot be Empty!'
    }
    if (isEmpty(selectedRoles)) {
      isFormValid = false
      temp.selectedRoles = 'roles cannot be Empty!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }
  const handleCreate = async () => {
    if (validateInfo()) {
      isEmpty(userData)
        ? addCallback({
            email_id: email,
            password: password,
            name: name,
            phone: phone,
            roles: selectedRoles,
          })
        : editCallback({
            user_id: userData._id,
            roles: selectedRoles,
          })
    }
  }

  return (
    <>
      <CModal size="lg" visible={openModal} alignment="center">
        <CModalHeader className="px-5 py-4">
          <CModalTitle>{isEmpty(userData) ? `Add User` : `Edit User Roles`} </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          {isEmpty(userData) && (
            <>
              <CRow>
                <CCol>
                  <CFormLabel>Name*</CFormLabel>
                  <CFormInput
                    type="text"
                    value={name}
                    name="name"
                    onChange={(e) => handleChange(e, setName)}
                  />
                  <div className="message-text error-message">
                    <p>{errorData.name}</p>
                  </div>
                </CCol>
                <CCol>
                  <CFormLabel>Phone</CFormLabel>
                  <CFormInput
                    type="number"
                    value={phone}
                    min="0"
                    name="phone"
                    onChange={(e) => handleChange(e, setPhone)}
                  />
                  <div className="message-text error-message">
                    <p>{errorData.phone}</p>
                  </div>
                </CCol>
              </CRow>
              <CRow className="mt-3">
                <CCol>
                  <CFormLabel>Email*</CFormLabel>
                  <CFormInput
                    type="email"
                    value={email}
                    name="email"
                    onChange={(e) => handleChange(e, setEmail)}
                  />
                  <div className="message-text error-message">
                    <p>{errorData.email}</p>
                  </div>
                </CCol>
                <CCol style={{ position: 'relative' }}>
                  <CFormLabel>Password*</CFormLabel>
                  <CFormInput
                    type={passwordHide ? 'password' : 'text'}
                    value={password}
                    name="password"
                    onChange={(e) => handleChange(e, setPassword)}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      right: '5%',
                      top: errorData.password || errorData.email ? '45%' : '55%',
                    }}
                  >
                    {!passwordHide ? (
                      <FontAwesomeIcon
                        icon={faEye}
                        size="lg"
                        onClick={() => setPasswordHide(true)}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faEyeSlash}
                        size="lg"
                        onClick={() => setPasswordHide(false)}
                      />
                    )}
                  </div>
                  <div className="message-text error-message">
                    <p>{errorData.password}</p>
                  </div>
                </CCol>
              </CRow>
            </>
          )}

          <CRow className="mt-3">
            <CCol lg="12">
              <CFormLabel>Select Roles*</CFormLabel>
              <Multiselect
                options={roleData} // Options to display in the dropdown
                selectedValues={!isEmpty(userData) ? selectedEditRoles : null}
                // color="red"
                style={{
                  chips: {
                    background: 'blue',
                  },
                  searchBox: {
                    background: 'white',
                  },
                }}
                showCheckbox="true"
                onSelect={(e, info) => handleSelectRoles(info, 'add')}
                onRemove={(e, info) => handleSelectRoles(info, 'remove')}
                displayValue="name"
              />
              <div className="message-text error-message">
                <p>{errorData.selectedRoles}</p>
              </div>
            </CCol>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleCreate}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default CreateCmsUser
